import { Redirect } from 'react-router-dom';
import { useCurrentUser } from '../Session';
import { UserType } from '../api';
import BasicLayout from '../layouts/BasicLayout';
import TagManagement from '../pages/TagManagement';

const TagManagementRoute = () => {
    const currentUser = useCurrentUser();

    if (![UserType.Admin, UserType.Approver].includes(currentUser.type)) {
        return <Redirect to="/403" />;
    }

    return (
        <BasicLayout>
            <TagManagement />
        </BasicLayout>
    );
};

export default TagManagementRoute;
